import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  offerActivationSuccess: {
    id: 'offerActivationSuccess',
    description: 'Message to show in success toast when offer was successfully activated',
    defaultMessage: 'Offer activated',
  },
  offerActivationError: {
    id: 'offerActivationError',
    description: 'Message to show in error toast when there was an error activating toast',
    defaultMessage: 'Error activating offer. Please try again.',
  },
});
